module.exports = __webpack_public_path__ + "img/A06-19980071-005.2ffa4cab.jpg";